import type {
  Accent,
  ResourceAccess,
  ResourceAgeGroup,
  ResourceContent,
  ResourceType,
} from '@viet-parenting/supabase/types';
import type { labels } from './i18n';

export type LabelKey = keyof (typeof labels)['vi'];

export const TYPE_LABEL_KEY: Record<ResourceType, LabelKey> = {
  video: 'type_video',
  audio: 'type_audio',
  book: 'type_book',
  worksheet: 'type_worksheet',
  app: 'type_app',
  other: 'type_other',
};

export const AGE_LABEL_KEY: Record<ResourceAgeGroup, LabelKey> = {
  '0-5': 'age_0_5',
  '6-11': 'age_6_11',
  '12-15': 'age_12_15',
  '15+': 'age_15_plus',
  parents: 'age_parents',
};

export const CONTENT_LABEL_KEY: Record<ResourceContent, LabelKey> = {
  language: 'content_language',
  culture: 'content_culture',
  stories: 'content_stories',
  identity: 'content_identity',
};

export const ACCESS_LABEL_KEY: Record<ResourceAccess, LabelKey> = {
  free: 'access_free',
  freemium: 'access_freemium',
  paid: 'access_paid',
};

export const ACCENT_LABEL_KEY: Record<Accent, LabelKey> = {
  northern: 'northern',
  central: 'central',
  southern: 'southern',
  mixed: 'mixed',
};

export const TYPE_OPTIONS: readonly ResourceType[] = [
  'video', 'audio', 'book', 'worksheet', 'app', 'other',
];
export const AGE_OPTIONS: readonly ResourceAgeGroup[] = [
  '0-5', '6-11', '12-15', '15+', 'parents',
];
export const CONTENT_OPTIONS: readonly ResourceContent[] = [
  'language', 'culture', 'stories', 'identity',
];
export const ACCESS_OPTIONS: readonly ResourceAccess[] = [
  'free', 'freemium', 'paid',
];
export const ACCENT_OPTIONS: readonly Accent[] = [
  'northern', 'central', 'southern', 'mixed',
];
